import { catchError, filter, mergeMap, of, retry, throwError, timer } from "rxjs";
import { fromFetch } from "rxjs/fetch";
import { getVisitId } from "../../login/src/formHelpers/metricsHelper";
var MetricsEvent;
(function (MetricsEvent) {
    MetricsEvent["ViewVisit"] = "view_visit";
    MetricsEvent["UIInteraction"] = "ui_interaction";
})(MetricsEvent || (MetricsEvent = {}));
export var UIType;
(function (UIType) {
    UIType["Input"] = "input";
    UIType["Button"] = "button";
    UIType["Checkbox"] = "checkbox";
    UIType["Toggle"] = "toggle";
})(UIType || (UIType = {}));
export var UIAction;
(function (UIAction) {
    UIAction["Enable"] = "enable";
    UIAction["Disable"] = "disable";
})(UIAction || (UIAction = {}));
export class CdpaRequest {
    static validateUsername(username) {
        const url = `${CdpaRequest.getApiPath()}/user-tag-root-validation/${username}`;
        return fetch(url).then((response) => response.json());
    }
    static sendUIInteractionMetrics(viewId, uiName, uiType, uiAction) {
        const viewName = viewId.replace(/-/g, "_");
        const body = {
            type: MetricsEvent.UIInteraction,
            uuid: window.crypto.randomUUID(),
            date: new Date().toISOString(),
            data: {
                view_name: viewName,
                ui_elements: {
                    ui_action: uiAction,
                    ui_name: uiName,
                    ui_type: uiType
                }
            }
        };
        CdpaRequest.sendMetrics(body);
    }
    static sendViewVisitMetrics(viewId) {
        const viewName = viewId.replace(/-/g, "_");
        const body = {
            type: MetricsEvent.ViewVisit,
            uuid: window.crypto.randomUUID(),
            date: new Date().toISOString(),
            data: {
                view_name: viewName
            }
        };
        CdpaRequest.sendMetrics(body);
    }
    static sendMetrics(body) {
        if (!window.environment.redsightsUrl) {
            console.warn("Can't send metrics event: no url found.");
            return;
        }
        const url = `${window.environment.redsightsUrl}/products/accounts/events`;
        fromFetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Visit": getVisitId()
            },
            body: JSON.stringify(body)
        })
            .pipe(catchError((error) => {
            console.error(error);
            return of(null);
        }), filter((response) => response != null), mergeMap((response) => {
            if (response.status.toString().startsWith("5")) {
                return throwError(() => "Error");
            }
            return of(response);
        }), retry({
            count: 3,
            delay: (_, count) => timer(count * 1000)
        }))
            .subscribe();
    }
    static getApiPath() {
        const realmId = window.location.pathname.split("/")[2];
        return `/realms/${realmId}`;
    }
}
